// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `*,
*::before,
*::after {
  box-sizing: border-box;
}

body {
  margin: 0;
  background: #000;
  color: #fff;
  font-family: system-ui, -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif;
}

/* MAIN WRAPPER */
.ck-dashboard {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  position: relative;
  overflow-x: hidden;
}

/* HAMBURGER MENU BUTTON 
   (Visible on Mobile, Hidden on Desktop)
*/
.ck-menu-btn {
  display: none;
  /* Hidden on Desktop */
  background: transparent;
  border: none;
  cursor: pointer;
  flex-direction: column;
  justify-content: space-between;
  width: 28px;
  height: 20px;
  padding: 0;
  z-index: 2000;
  /* Stays above other elements */
}

.ck-menu-btn .menu-line {
  display: block;
  width: 100%;
  height: 2px;
  background-color: #fff;
  border-radius: 2px;
}

/* Hamburger to 'X' animation */
.ck-menu-btn.open .menu-line:nth-child(1) {
  transform: rotate(45deg) translate(5px, 6px);
}

.ck-menu-btn.open .menu-line:nth-child(2) {
  opacity: 0;
}

.ck-menu-btn.open .menu-line:nth-child(3) {
  transform: rotate(-45deg) translate(5px, -6px);
}


/* HEADER */
.ck-navbar {
  background: #000;
  height: 80px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 24px;
  position: sticky;
  top: 0;
  z-index: 1500;
  border-bottom: 1px solid #1a1a1a;
  flex-shrink: 0;
}

.ck-navbar-brand {
  display: flex;
  flex-direction: column;
  justify-content: center;
  line-height: 1.1;
}

.brand-text-top {
  color: #fff;
  font-size: 18px;
  font-weight: 300;
  letter-spacing: 0.5px;
}

.brand-text-bottom {
  color: #ff8a3d;
  font-size: 18px;
  text-transform: uppercase;
  font-weight: 400;
  letter-spacing: 1px;
}

/* BODY WRAPPER (Sidebar + Main Content) */
.dashboard-body {
  display: flex;
  flex: 1 1;
  /* Pushes footer down and fills space */
  width: 100%;
}

/* SIDEBAR */
.ck-sidebar {
  width: 260px;
  background: #111;
  border-right: 1px solid #2a2a2a;
  padding: 24px;
  display: flex;
  flex-direction: column;
  z-index: 100;
}

.ck-sidebar-close {
  position: absolute;
  top: 20px;
  right: 20px;
  background: transparent;
  border: none;
  color: #fff;
  font-size: 26px;
  font-weight: 300;
  cursor: pointer;
  padding: 5px;
  line-height: 1;
}

.ck-sidebar-close:hover {
  color: #ff8a3d;
}

/* NAVIGATION LINKS */
.ck-nav {

  display: flex;
  flex-direction: column;
  gap: 14px;
}

.ck-nav-item {
  background: transparent;
  color: #b7b7b7;
  padding: 12px 10px;
  border: none;
  cursor: pointer;
  text-align: left;
  font-size: 14px;
  letter-spacing: 0.05em;
  text-decoration: none;
  display: block;
}

.ck-nav-mobile-menu {
  display: none;
  /* Hidden on desktop */
  flex-direction: column;
  gap: 14px;
}

.ck-nav-divider {
  height: 1px;
  background: #333;
  margin: 8px 0;
}

.ck-nav-item:hover {
  color: #fff;
}

.ck-nav-item--active {
  color: #fff;
  font-weight: 600;
  border-left: 3px solid #ff8a3d;
  padding-left: 7px;
}

/* SIDEBAR USER PROFILE */
.ck-sidebar-user {
  margin-top: auto;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 8px;
  border-top: 1px solid #222;
  padding-top: 18px;
  padding-bottom: 24px;
  width: 100%;
}

.ck-avatar {
  width: 38px;
  height: 38px;
  border-radius: 50%;
  background: #222;
  border: 2.5px solid #ff8a3d;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
  color: #fff;
}

.ck-sidebar-user .ck-user-meta {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-left: 0;
  color: #fff;
}

.ck-sidebar-user .ck-user-email {
  color: #fff;
  font-size: 13px;
  opacity: 0.95;
  margin-bottom: 10px;
  word-break: break-all;
}

.ck-sidebar-user .ck-link-button {
  color: #ff8a3d;
  font-size: 13px;
  font-weight: 600;
  padding: 0;
  background: none;
  border: none;
  cursor: pointer;
}

/* MAIN CONTENT AREA */
.ck-main {
  flex: 1 1;
  width: 100%;
  display: flex;
  flex-direction: column;
  background: #0a0a0a;
  min-width: 0;
}

.ck-content {
  padding: 25px;
  flex: 1 1;
  scrollbar-width: thin;
  scrollbar-color: #ff8a3d;
}

.ck-panel-title {
  font-size: 20px;
  font-weight: 600;
  margin-bottom: 16px;
}

/* TABLE STYLING */
.ck-table-wrapper {
  overflow-x: auto;
  overflow-y: hidden;
  margin-top: 20px;
  border: 1px solid #222;
  border-radius: 6px;
  position: relative;
  padding-bottom: 12px;
  scrollbar-width: thin;
  scrollbar-color: #ff8a3d #111;
  scrollbar-gutter: stable both-edges;
}

.ck-table-wrapper::after {
  content: "";
  position: absolute;
  bottom: 4px;
  left: 8px;
  right: 8px;
  height: 4px;
  border-radius: 999px;
  background: linear-gradient(90deg, transparent 0%, rgba(255, 145, 77, 0.1) 40%, rgba(255, 145, 77, 0.6) 60%, rgba(255, 145, 77, 0.15) 100%);
  pointer-events: none;
  z-index: 10;
}

.ck-table-wrapper::-webkit-scrollbar {
  height: 6px;
}

.ck-table-wrapper::-webkit-scrollbar-track {
  background: #111;
  border-radius: 999px;
}

.ck-table-wrapper::-webkit-scrollbar-thumb {
  background: #f59255;
  border-radius: 999px;
}

.ck-table {
  width: 100%;
  border-collapse: collapse;
  background: #111;
  min-width: 600px;
}

.ck-table th,
.ck-table td {
  padding: 14px;
  border-bottom: 1px solid #333;
  text-align: left;
  font-size: 14px;
}

.ck-table th {
  background-color: #0a0a0a;
  color: #888;
  font-weight: 500;
}

.ck-table tr:hover {
  background: #1a1a1a;
}

/* STATUS TAGS */
.ck-status-badge {
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  font-weight: 600;
  text-transform: capitalize;
}

.ck-status-badge.paid {
  background: rgba(63, 195, 104, 0.2);
  color: #3fc368;
  border: 1px solid #3fc368;
}

.ck-status-badge.sent {
  background: rgba(255, 145, 77, 0.15);
  color: #f59255;
  border: 1px solid #f59255;
}

.ck-status-badge.pending {
  background: rgba(255, 193, 7, 0.2);
  color: #ffc107;
  border: 1px solid #ffc107;
}

.ck-status-badge.booked {
  background: rgba(63, 140, 255, 0.2);
  color: #3f8cff;
  border: 1px solid #3f8cff;
}

.ck-status-badge.processing {
  background: rgba(150, 150, 150, 0.2);
  color: #ccc;
  border: 1px solid #666;
}

.ck-status-badge.other {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
  border: 1px solid #555;
}

/* PAGINATION */
.ck-pagination {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 15px;
  margin-top: 20px;
  padding: 10px 0;
}

.ck-page-info {
  font-size: 14px;
  color: #888;
}

.ck-page-btn {
  background: #111;
  border: 1px solid #333;
  color: #fff;
  padding: 6px 14px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 13px;
}

.ck-page-btn:hover:not(:disabled) {
  border-color: #ff8a3d;
  color: #ff8a3d;
}

.ck-page-btn:disabled {
  opacity: 0.5;
  cursor: default;
}

/* FOOTER */
.ck-footer {
  background: #0A0A0A;
  border-top: 2px solid #ff8a3d;
  padding: 16px 0;
  font-size: 12px;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: auto;
  z-index: 10;
}

.container-footer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;
  gap: 8px;
  padding: 0 20px;
  text-align: center;
}

.container-footer a {
  text-decoration: none;
  color: #ccc;
  font-weight: 500;
}

.container-footer a:hover {
  color: #ff8a3d;
}

.container-footer span {
  color: #444;
}

.footer-pipe {
  color: white;
  margin: 0 8px;
  font-weight: bold;
}

/* PASSWORD SECTION */
.ck-password-tabs {
  display: flex;
  margin: 20px 0 20px 0;
  border-bottom: 1px solid #222;
  gap: 20px;
}

.ck-password-tabs button {
  background: none;
  color: #666;
  border: none;
  font-size: 14px;
  padding: 10px 0;
  cursor: pointer;
  position: relative;
}

.ck-password-tabs button.active {
  color: #fff;
  font-weight: 600;
}

.ck-password-tabs button.active::after {
  content: '';
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  height: 2px;
  background: #ff8a3d;
}

/* INPUT + BUTTON LAYOUT */
.ck-pass-box {
  margin-top: 18px;
  display: flex;
  flex-direction: column;
  gap: 16px;
  max-width: 500px;
}

.ck-input {
  width: 100%;
  padding: 12px;
  background: #111;
  color: #fff;
  border: 1px solid #333;
  border-radius: 6px;
  font-size: 14px;
}

.ck-input:focus {
  border-color: #ff8a3d;
  outline: none;
}

.ck-row {
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
}

.ck-row .ck-input {
  flex: 1 1;
}

.ck-btn-sm {
  height: 42px;
  padding: 0 20px;
  background: #ff8a3d;
  color: #000;
  border: none;
  border-radius: 6px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
}

.ck-btn-sm:hover {
  background: #ff9b56;
}

.ck-btn-sm:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

/* ERROR / SUCCESS */
.ck-error {
  color: #ff4f4f;
  font-size: 13px;
  background: rgba(255, 79, 79, 0.1);
  padding: 10px;
  border-radius: 4px;
}

.ck-success {
  color: #3fc368;
  font-size: 13px;
  font-weight: 500;
  background: rgba(63, 195, 104, 0.1);
  padding: 10px;
  border-radius: 4px;
}

/* -------------------------------------
   MEDIA QUERIES (Mobile) 
   ------------------------------------- */

@media (max-width: 768px) {

  /* Show hamburger button */
  .ck-menu-btn {
    display: flex;
  }

  /* Hide the dashboard header on mobile since CKNavbar is used */
  .ck-navbar {
    display: none;
  }

  /* Body stacks vertically on mobile */
  .dashboard-body {
    flex-direction: column;
  }

  /* Sidebar becomes off-canvas drawer */
  .ck-sidebar {
    position: fixed;
    top: 60px;
    /* Below the CKNavbar (60px) */
    left: 0;
    width: 100%;
    height: calc(100vh - 60px);
    /* Fill rest of screen */
    transform: translateX(-100%);
    /* Hide left by default */
    border-right: none;
    border-bottom: 1px solid #222;
  }

  /* Slide in when open */
  .ck-sidebar.open {
    transform: translateX(0);
    box-shadow: 5px 0 20px rgba(0, 0, 0, 0.5);
  }

  /* Show mobile menu links */
  .ck-nav-mobile-menu {
    display: flex;
  }

  /* Hide CKNavbar drawer on mobile (we use the sidebar instead) */
  .ck-dashboard .ck-navbar-drawer {
    display: none !important;
  }

  /* Footer adjustments for mobile */
  .container-footer {
    padding: 0 16px;
    flex-direction: row;
  }

  .container-footer a {
    font-size: 0.85rem;
    white-space: nowrap;
  }
}

@media (max-width: 600px) {
  .ck-row {
    flex-direction: column;
    align-items: stretch;
  }

  .ck-btn-sm {
    width: 100%;
  }
}`, "",{"version":3,"sources":["webpack://./src/DashboardLayout.css"],"names":[],"mappings":"AAAA;;;EAGE,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,WAAW;EACX,yFAAyF;AAC3F;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;;CAEC;AACD;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,sBAAsB;EACtB,8BAA8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,aAAa;EACb,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,WAAW;EACX,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA,+BAA+B;AAC/B;EACE,4CAA4C;AAC9C;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8CAA8C;AAChD;;;AAGA,WAAW;AACX;EACE,gBAAgB;EAChB,YAAY;EACZ,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,MAAM;EACN,aAAa;EACb,gCAAgC;EAChC,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,yBAAyB;EACzB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,0CAA0C;AAC1C;EACE,aAAa;EACb,SAAO;EACP,uCAAuC;EACvC,WAAW;AACb;;AAEA,YAAY;AACZ;EACE,YAAY;EACZ,gBAAgB;EAChB,+BAA+B;EAC/B,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,YAAY;EACZ,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,qBAAqB;AACrB;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sBAAsB;EACtB,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;AACnB;;AAEA,yBAAyB;AACzB;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,QAAQ;EACR,0BAA0B;EAC1B,iBAAiB;EACjB,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,cAAc;EACd,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,SAAO;EACP,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,SAAO;EACP,qBAAqB;EACrB,wBAAwB;AAC1B;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,oBAAoB;EACpB,qBAAqB;EACrB,6BAA6B;EAC7B,mCAAmC;AACrC;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,UAAU;EACV,WAAW;EACX,oBAAoB;EACpB,2IAA2I;EAC3I,oBAAoB;EACpB,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;EACb,6BAA6B;EAC7B,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,yBAAyB;EACzB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,kCAAkC;EAClC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mCAAmC;EACnC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,oCAAoC;EACpC,WAAW;EACX,sBAAsB;AACxB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,SAAS;EACT,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,iBAAiB;EACjB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,eAAe;AACjB;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,6BAA6B;EAC7B,eAAe;EACf,eAAe;EACf,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,eAAe;EACf,QAAQ;EACR,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,iBAAiB;AACnB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,qBAAqB;EACrB,6BAA6B;EAC7B,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,YAAY;EACZ,eAAe;EACf,eAAe;EACf,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,kBAAkB;EAClB,YAAY;EACZ,OAAO;EACP,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,WAAW;AACb;;AAEA;EACE,SAAO;AACT;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,mBAAmB;EACnB,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,eAAe;EACf,kCAAkC;EAClC,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,mCAAmC;EACnC,aAAa;EACb,kBAAkB;AACpB;;AAEA;;0CAE0C;;AAE1C;;EAEE,0BAA0B;EAC1B;IACE,aAAa;EACf;;EAEA,+DAA+D;EAC/D;IACE,aAAa;EACf;;EAEA,qCAAqC;EACrC;IACE,sBAAsB;EACxB;;EAEA,sCAAsC;EACtC;IACE,eAAe;IACf,SAAS;IACT,8BAA8B;IAC9B,OAAO;IACP,WAAW;IACX,0BAA0B;IAC1B,wBAAwB;IACxB,4BAA4B;IAC5B,yBAAyB;IACzB,kBAAkB;IAClB,6BAA6B;EAC/B;;EAEA,uBAAuB;EACvB;IACE,wBAAwB;IACxB,yCAAyC;EAC3C;;EAEA,2BAA2B;EAC3B;IACE,aAAa;EACf;;EAEA,gEAAgE;EAChE;IACE,wBAAwB;EAC1B;;EAEA,kCAAkC;EAClC;IACE,eAAe;IACf,mBAAmB;EACrB;;EAEA;IACE,kBAAkB;IAClB,mBAAmB;EACrB;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,oBAAoB;EACtB;;EAEA;IACE,WAAW;EACb;AACF","sourcesContent":["*,\n*::before,\n*::after {\n  box-sizing: border-box;\n}\n\nbody {\n  margin: 0;\n  background: #000;\n  color: #fff;\n  font-family: system-ui, -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, sans-serif;\n}\n\n/* MAIN WRAPPER */\n.ck-dashboard {\n  display: flex;\n  flex-direction: column;\n  min-height: 100vh;\n  position: relative;\n  overflow-x: hidden;\n}\n\n/* HAMBURGER MENU BUTTON \n   (Visible on Mobile, Hidden on Desktop)\n*/\n.ck-menu-btn {\n  display: none;\n  /* Hidden on Desktop */\n  background: transparent;\n  border: none;\n  cursor: pointer;\n  flex-direction: column;\n  justify-content: space-between;\n  width: 28px;\n  height: 20px;\n  padding: 0;\n  z-index: 2000;\n  /* Stays above other elements */\n}\n\n.ck-menu-btn .menu-line {\n  display: block;\n  width: 100%;\n  height: 2px;\n  background-color: #fff;\n  border-radius: 2px;\n}\n\n/* Hamburger to 'X' animation */\n.ck-menu-btn.open .menu-line:nth-child(1) {\n  transform: rotate(45deg) translate(5px, 6px);\n}\n\n.ck-menu-btn.open .menu-line:nth-child(2) {\n  opacity: 0;\n}\n\n.ck-menu-btn.open .menu-line:nth-child(3) {\n  transform: rotate(-45deg) translate(5px, -6px);\n}\n\n\n/* HEADER */\n.ck-navbar {\n  background: #000;\n  height: 80px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 0 24px;\n  position: sticky;\n  top: 0;\n  z-index: 1500;\n  border-bottom: 1px solid #1a1a1a;\n  flex-shrink: 0;\n}\n\n.ck-navbar-brand {\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  line-height: 1.1;\n}\n\n.brand-text-top {\n  color: #fff;\n  font-size: 18px;\n  font-weight: 300;\n  letter-spacing: 0.5px;\n}\n\n.brand-text-bottom {\n  color: #ff8a3d;\n  font-size: 18px;\n  text-transform: uppercase;\n  font-weight: 400;\n  letter-spacing: 1px;\n}\n\n/* BODY WRAPPER (Sidebar + Main Content) */\n.dashboard-body {\n  display: flex;\n  flex: 1;\n  /* Pushes footer down and fills space */\n  width: 100%;\n}\n\n/* SIDEBAR */\n.ck-sidebar {\n  width: 260px;\n  background: #111;\n  border-right: 1px solid #2a2a2a;\n  padding: 24px;\n  display: flex;\n  flex-direction: column;\n  z-index: 100;\n}\n\n.ck-sidebar-close {\n  position: absolute;\n  top: 20px;\n  right: 20px;\n  background: transparent;\n  border: none;\n  color: #fff;\n  font-size: 26px;\n  font-weight: 300;\n  cursor: pointer;\n  padding: 5px;\n  line-height: 1;\n}\n\n.ck-sidebar-close:hover {\n  color: #ff8a3d;\n}\n\n/* NAVIGATION LINKS */\n.ck-nav {\n\n  display: flex;\n  flex-direction: column;\n  gap: 14px;\n}\n\n.ck-nav-item {\n  background: transparent;\n  color: #b7b7b7;\n  padding: 12px 10px;\n  border: none;\n  cursor: pointer;\n  text-align: left;\n  font-size: 14px;\n  letter-spacing: 0.05em;\n  text-decoration: none;\n  display: block;\n}\n\n.ck-nav-mobile-menu {\n  display: none;\n  /* Hidden on desktop */\n  flex-direction: column;\n  gap: 14px;\n}\n\n.ck-nav-divider {\n  height: 1px;\n  background: #333;\n  margin: 8px 0;\n}\n\n.ck-nav-item:hover {\n  color: #fff;\n}\n\n.ck-nav-item--active {\n  color: #fff;\n  font-weight: 600;\n  border-left: 3px solid #ff8a3d;\n  padding-left: 7px;\n}\n\n/* SIDEBAR USER PROFILE */\n.ck-sidebar-user {\n  margin-top: auto;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 8px;\n  border-top: 1px solid #222;\n  padding-top: 18px;\n  padding-bottom: 24px;\n  width: 100%;\n}\n\n.ck-avatar {\n  width: 38px;\n  height: 38px;\n  border-radius: 50%;\n  background: #222;\n  border: 2.5px solid #ff8a3d;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: bold;\n  color: #fff;\n}\n\n.ck-sidebar-user .ck-user-meta {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  margin-left: 0;\n  color: #fff;\n}\n\n.ck-sidebar-user .ck-user-email {\n  color: #fff;\n  font-size: 13px;\n  opacity: 0.95;\n  margin-bottom: 10px;\n  word-break: break-all;\n}\n\n.ck-sidebar-user .ck-link-button {\n  color: #ff8a3d;\n  font-size: 13px;\n  font-weight: 600;\n  padding: 0;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n/* MAIN CONTENT AREA */\n.ck-main {\n  flex: 1;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  background: #0a0a0a;\n  min-width: 0;\n}\n\n.ck-content {\n  padding: 25px;\n  flex: 1;\n  scrollbar-width: thin;\n  scrollbar-color: #ff8a3d;\n}\n\n.ck-panel-title {\n  font-size: 20px;\n  font-weight: 600;\n  margin-bottom: 16px;\n}\n\n/* TABLE STYLING */\n.ck-table-wrapper {\n  overflow-x: auto;\n  overflow-y: hidden;\n  margin-top: 20px;\n  border: 1px solid #222;\n  border-radius: 6px;\n  position: relative;\n  padding-bottom: 12px;\n  scrollbar-width: thin;\n  scrollbar-color: #ff8a3d #111;\n  scrollbar-gutter: stable both-edges;\n}\n\n.ck-table-wrapper::after {\n  content: \"\";\n  position: absolute;\n  bottom: 4px;\n  left: 8px;\n  right: 8px;\n  height: 4px;\n  border-radius: 999px;\n  background: linear-gradient(90deg, transparent 0%, rgba(255, 145, 77, 0.1) 40%, rgba(255, 145, 77, 0.6) 60%, rgba(255, 145, 77, 0.15) 100%);\n  pointer-events: none;\n  z-index: 10;\n}\n\n.ck-table-wrapper::-webkit-scrollbar {\n  height: 6px;\n}\n\n.ck-table-wrapper::-webkit-scrollbar-track {\n  background: #111;\n  border-radius: 999px;\n}\n\n.ck-table-wrapper::-webkit-scrollbar-thumb {\n  background: #f59255;\n  border-radius: 999px;\n}\n\n.ck-table {\n  width: 100%;\n  border-collapse: collapse;\n  background: #111;\n  min-width: 600px;\n}\n\n.ck-table th,\n.ck-table td {\n  padding: 14px;\n  border-bottom: 1px solid #333;\n  text-align: left;\n  font-size: 14px;\n}\n\n.ck-table th {\n  background-color: #0a0a0a;\n  color: #888;\n  font-weight: 500;\n}\n\n.ck-table tr:hover {\n  background: #1a1a1a;\n}\n\n/* STATUS TAGS */\n.ck-status-badge {\n  padding: 5px 10px;\n  border-radius: 4px;\n  font-size: 12px;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.ck-status-badge.paid {\n  background: rgba(63, 195, 104, 0.2);\n  color: #3fc368;\n  border: 1px solid #3fc368;\n}\n\n.ck-status-badge.sent {\n  background: rgba(255, 145, 77, 0.15);\n  color: #f59255;\n  border: 1px solid #f59255;\n}\n\n.ck-status-badge.pending {\n  background: rgba(255, 193, 7, 0.2);\n  color: #ffc107;\n  border: 1px solid #ffc107;\n}\n\n.ck-status-badge.booked {\n  background: rgba(63, 140, 255, 0.2);\n  color: #3f8cff;\n  border: 1px solid #3f8cff;\n}\n\n.ck-status-badge.processing {\n  background: rgba(150, 150, 150, 0.2);\n  color: #ccc;\n  border: 1px solid #666;\n}\n\n.ck-status-badge.other {\n  background: rgba(255, 255, 255, 0.1);\n  color: #fff;\n  border: 1px solid #555;\n}\n\n/* PAGINATION */\n.ck-pagination {\n  display: flex;\n  justify-content: flex-end;\n  align-items: center;\n  gap: 15px;\n  margin-top: 20px;\n  padding: 10px 0;\n}\n\n.ck-page-info {\n  font-size: 14px;\n  color: #888;\n}\n\n.ck-page-btn {\n  background: #111;\n  border: 1px solid #333;\n  color: #fff;\n  padding: 6px 14px;\n  border-radius: 4px;\n  cursor: pointer;\n  font-size: 13px;\n}\n\n.ck-page-btn:hover:not(:disabled) {\n  border-color: #ff8a3d;\n  color: #ff8a3d;\n}\n\n.ck-page-btn:disabled {\n  opacity: 0.5;\n  cursor: default;\n}\n\n/* FOOTER */\n.ck-footer {\n  background: #0A0A0A;\n  border-top: 2px solid #ff8a3d;\n  padding: 16px 0;\n  font-size: 12px;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  margin-top: auto;\n  z-index: 10;\n}\n\n.container-footer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-wrap: wrap;\n  gap: 8px;\n  padding: 0 20px;\n  text-align: center;\n}\n\n.container-footer a {\n  text-decoration: none;\n  color: #ccc;\n  font-weight: 500;\n}\n\n.container-footer a:hover {\n  color: #ff8a3d;\n}\n\n.container-footer span {\n  color: #444;\n}\n\n.footer-pipe {\n  color: white;\n  margin: 0 8px;\n  font-weight: bold;\n}\n\n/* PASSWORD SECTION */\n.ck-password-tabs {\n  display: flex;\n  margin: 20px 0 20px 0;\n  border-bottom: 1px solid #222;\n  gap: 20px;\n}\n\n.ck-password-tabs button {\n  background: none;\n  color: #666;\n  border: none;\n  font-size: 14px;\n  padding: 10px 0;\n  cursor: pointer;\n  position: relative;\n}\n\n.ck-password-tabs button.active {\n  color: #fff;\n  font-weight: 600;\n}\n\n.ck-password-tabs button.active::after {\n  content: '';\n  position: absolute;\n  bottom: -1px;\n  left: 0;\n  width: 100%;\n  height: 2px;\n  background: #ff8a3d;\n}\n\n/* INPUT + BUTTON LAYOUT */\n.ck-pass-box {\n  margin-top: 18px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n  max-width: 500px;\n}\n\n.ck-input {\n  width: 100%;\n  padding: 12px;\n  background: #111;\n  color: #fff;\n  border: 1px solid #333;\n  border-radius: 6px;\n  font-size: 14px;\n}\n\n.ck-input:focus {\n  border-color: #ff8a3d;\n  outline: none;\n}\n\n.ck-row {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  width: 100%;\n}\n\n.ck-row .ck-input {\n  flex: 1;\n}\n\n.ck-btn-sm {\n  height: 42px;\n  padding: 0 20px;\n  background: #ff8a3d;\n  color: #000;\n  border: none;\n  border-radius: 6px;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.ck-btn-sm:hover {\n  background: #ff9b56;\n}\n\n.ck-btn-sm:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n/* ERROR / SUCCESS */\n.ck-error {\n  color: #ff4f4f;\n  font-size: 13px;\n  background: rgba(255, 79, 79, 0.1);\n  padding: 10px;\n  border-radius: 4px;\n}\n\n.ck-success {\n  color: #3fc368;\n  font-size: 13px;\n  font-weight: 500;\n  background: rgba(63, 195, 104, 0.1);\n  padding: 10px;\n  border-radius: 4px;\n}\n\n/* -------------------------------------\n   MEDIA QUERIES (Mobile) \n   ------------------------------------- */\n\n@media (max-width: 768px) {\n\n  /* Show hamburger button */\n  .ck-menu-btn {\n    display: flex;\n  }\n\n  /* Hide the dashboard header on mobile since CKNavbar is used */\n  .ck-navbar {\n    display: none;\n  }\n\n  /* Body stacks vertically on mobile */\n  .dashboard-body {\n    flex-direction: column;\n  }\n\n  /* Sidebar becomes off-canvas drawer */\n  .ck-sidebar {\n    position: fixed;\n    top: 60px;\n    /* Below the CKNavbar (60px) */\n    left: 0;\n    width: 100%;\n    height: calc(100vh - 60px);\n    /* Fill rest of screen */\n    transform: translateX(-100%);\n    /* Hide left by default */\n    border-right: none;\n    border-bottom: 1px solid #222;\n  }\n\n  /* Slide in when open */\n  .ck-sidebar.open {\n    transform: translateX(0);\n    box-shadow: 5px 0 20px rgba(0, 0, 0, 0.5);\n  }\n\n  /* Show mobile menu links */\n  .ck-nav-mobile-menu {\n    display: flex;\n  }\n\n  /* Hide CKNavbar drawer on mobile (we use the sidebar instead) */\n  .ck-dashboard .ck-navbar-drawer {\n    display: none !important;\n  }\n\n  /* Footer adjustments for mobile */\n  .container-footer {\n    padding: 0 16px;\n    flex-direction: row;\n  }\n\n  .container-footer a {\n    font-size: 0.85rem;\n    white-space: nowrap;\n  }\n}\n\n@media (max-width: 600px) {\n  .ck-row {\n    flex-direction: column;\n    align-items: stretch;\n  }\n\n  .ck-btn-sm {\n    width: 100%;\n  }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
